import React from "react";
import { useTranslation } from "react-i18next";

//irina
function Experience() {
  const { t } = useTranslation("homepage");

  return (
    <section className="tc-experience-style1 section-padding-x">
      <div className="container-fluid">
        <div className="row justify-content-between align-items-center">
          <div className="col-lg-2">
            <div
              className="exp-num mb-100 wow zoomIn"
              data-wow-delay="0.3s"
            ></div>
          </div>
          <div className="col-lg-3">
            <div className="img wow animated">
              <img
                src="/home1/assets/img/slider/4.jpg"
                alt="Botanicheska Gardens"
                className="img-cover"
              />
            </div>
          </div>
          <div className="col-lg-3">
            <div className="info wow fadeInUp" data-wow-delay="0.3s">
              <h3 className="fsz-45 fw-600 mb-30">
                {" "}
                {t("experience.mainTitle")}{" "}
              </h3>
              <div className="text fsz-15 color-666">
                {t("experience.description")
                  .split(/(botanicheska 302)/i)
                  .map((part, index) =>
                    part.toLowerCase() === "botanicheska 302" ? (
                      <span
                        key={index}
                        style={{
                          fontFamily: "TheSeasons",
                          textTransform: "uppercase",
                        }}
                      >
                        {part}
                      </span>
                    ) : (
                      part
                    )
                  )}
              </div>

              <a
                href="innerpages/floor?entrance=А&floor=1"
                className="butn border rounded-pill mt-60 hover-bg-white"
              >
                <span>
                  {t("experience.buttons.apartments")}
                  <i className="small ms-1 ti-arrow-top-right"></i>
                </span>
              </a>
              <a
                href="innerpages/floor?entrance=А&floor=-1"
                className="butn border rounded-pill mt-10 hover-bg-white"
              >
                <span>
                  {t("experience.buttons.parking")}
                  <i className="small ms-1 ti-arrow-top-right"></i>
                </span>
              </a>
            </div>
          </div>
          <div className="col-lg-2">
            {/* <div className="rotate-txt justify-content-lg-end">
              <ul>
                <li>
                  <a href="mailto:sales@botanicheska.com ">
                    {" "}
                    {t("experience.contact.email")}{" "}
                  </a>
                </li>
                <li>
                  <a href="/innerpages/contact">
                    {" "}
                    {t("experience.contact.inquiry")}{" "}
                  </a>
                </li>
              </ul>
            </div> */}
          </div>
        </div>
      </div>
      <img src="/home1/assets/img/c_line.png" alt="" className="c-line wow" />
    </section>
  );
}

export default Experience;
